
import React from 'react';
import type { AIFixSteps } from '../types';

interface FixStepsDisplayProps {
    fix: AIFixSteps;
    cause: string;
    onReset: () => void;
}

export const FixStepsDisplay: React.FC<FixStepsDisplayProps> = ({ fix, cause, onReset }) => {
    return (
        <div className="p-6 sm:p-8">
            <div className="text-center mb-6">
                <h2 className="text-xl font-semibold text-gray-700">Repair Instructions</h2>
                <p className="text-sm text-gray-500 mt-1">For issue: <span className="font-medium text-gray-800">{cause}</span></p>
            </div>
            
            <div className="space-y-3 bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ol className="list-decimal list-inside space-y-3 text-gray-700">
                    {fix.steps.map((step, index) => (
                        <li key={index} className="pl-2 leading-relaxed">
                           {step}
                        </li>
                    ))}
                </ol>
            </div>

            <div className="mt-8 text-center">
                <button
                    onClick={onReset}
                    className="px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#002A5C] hover:bg-[#001F44] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Start New Diagnosis
                </button>
            </div>
        </div>
    );
};
